import api from '@/services/api'
import { getField, updateField } from 'vuex-map-fields'
import * as utils from '@/mixins/utils'

export default {
  namespaced: true,
  state: {
    medico: {},
    listaUF: [],
    listaRepasse: [],
    foto: ''
  },
  getters: {
    getField
  },
  actions: {
    abrirMedico ({ commit }, payload) {
      // const objVazio = Object.assign({}, this.objVazio)
      const objVazio = {
        cd_medico: '',
        ds_medico: '',
        ds_crm_nr: '',
        ds_crm_uf: '',
        ds_email: '',
        sn_ativo: true,
        sn_clinico: false,
        ds_especialidade: '',
        ds_senha: '',
        cd_funcionario: ''
      }
      return api().post('se1/doCadastro', {
        ds_tabela: 'medicos',
        cd_codigo: payload.id,
        cd_operacao: payload.op,
        js_tabela: btoa(JSON.stringify(payload.obj || objVazio))
      }).then(response => {
        if (!response?.data.length) {
          commit('SET_MEDICO', objVazio)
        } else if (!(response.data[0].erro || response.data[0].falha)) {
          commit('SET_MEDICO', response.data[0])
        }
        return response
      }).catch(e => {
        commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
      })
    },
    doListaUF ({ commit }) {
      api().post('se1/doListaUF').then(response => {
        commit('SET_UF', response.data)
      }).catch(e => {
        commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
      })
    },
    doLaudoMedico ({ commit }, payload) {
      return api().post('se1/doLaudoMedico', { cd_atendimento: payload.cd_atendimento, cd_medico: payload.cd_medico })
    },
    doLaudoRevisor ({ commit }, payload) {
      return api().post('se1/doLaudoRevisor', { cd_atendimento: payload.cd_atendimento, cd_medico: payload.cd_medico })
    },
    doMedicoRepasse ({ commit }, payload) {
      api().post('se1/doMedicoRepasse', payload).then(response => {
        commit('SET_REPASSE', response.data)
      }).catch(e => {
        commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
      })
    },
    doMedicoFoto ({ commit }, payload) {
      if (payload) {
        api().post('se1/doMedicoFoto', { cd_medico: payload }).then(response => {
          let bbFoto = response.data[0]?.bb_foto
          bbFoto = bbFoto ? `data:${utils.tipoImagem(bbFoto)};base64,${bbFoto}` : null
          commit('SET_FOTO', bbFoto)
        }).catch(e => {
          commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
        })
      } else {
        commit('SET_FOTO', null)
      }
    },
    doMedicoNewPassword ({ commit }, payload) {
      return api().post('se1/doMedicoNewPassword', payload).then(response => {
        if (response.data[0].Sucesso) {
          commit('layout/SET_ALERTA', { mensagem: response.data[0].Sucesso, tipo: 'success' }, { root: true })
        } else {
          commit('layout/SET_ALERTA', { mensagem: response.data[0].Erro || response.data[0].Falha }, { root: true })
        }
        return response
      }).catch(e => {
        commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
      })
    },
    doMedicoPassword ({ commit }, payload) {
      api().post('se1/doMedicoPassword', { ds_email: payload }).then(response => {
        if (response.data[0]?.Sucesso) {
          commit('layout/SET_ALERTA', { mensagem: response.data[0].Sucesso, tipo: 'success' }, { root: true })
        } else {
          commit('layout/SET_ALERTA', { mensagem: response.data[0]?.Erro || response.data[0]?.Falha }, { root: true })
        }
        return response
      }).catch(e => {
        commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
      })
    }
  },
  mutations: {
    updateField,
    SET_UF (state, payload) {
      state.listaUF = []
      payload[0].UF.split(',').forEach(estado => {
        state.listaUF.push({ ds_estado: estado })
      })
    },
    SET_MEDICO (state, payload) {
      state.medico = payload
    },
    SET_REPASSE (state, payload) {
      state.listaRepasse = payload
    },
    SET_FOTO (state, payload) {
      state.foto = payload
    }
  }
}
